export const provideThemeSettings = {
  computed: {
    $_themeTextColorClass() {
      return {
        'white--text': this.$vuetify.theme.dark,
      };
    },
  },
};
